<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
       size="50"
      is-full-screen
    />
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-snackbar v-model="showsnackbar" color="#9eaade" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout justify-center wrap>
      <v-flex xs12 pt-5>
        <v-card>
          <v-layout justify-start wrap py-6>
            <v-layout justify-center wrap>
              <v-flex xs3 sm3 md3 pl-5 text-center>
               <v-img width="30px" src="./../../assets/images/class.svg"></v-img>
              </v-flex>
              <v-flex xs9 sm9 md9 text-left>
                <span
                  style="
                    font-family: nunitosansbold;
                    font-size: 20px;
                    color: #000000;
                  "
                  >Add Class</span>
              </v-flex>
            </v-layout>
            <v-flex xs6 sm6 md9>
              <router-link :to="'/addClass'" style="text-decoration: none">
                <span
                  style="
                    color: #797979;
                    font-family: nunitosanssemibold;
                    font-size: 18px;
                  "
                  >View Class</span>
              </router-link>
            </v-flex></v-layout>
          <v-card-text v-if="!user && data.length > 0">
            <v-layout justify-center wrap>
              <v-flex xs12 sm6 md6 pa-2 v-if="data[0].class">
                <v-select
                  v-model="data[0].class.standard"
                  dense
                  style="font-family: nunitosanssemibold"
                  outlined
                  label="Class"
                  :items="standardArray"
                  item-text="standardName"
                  item-value="_id"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md6 pa-2 v-if="data[0].class">
                <v-text-field
                  v-model="data[0].class.division.divisionName"
                  @keyup="uppercase"
                  label="Section"
                  dense
                  style="font-family: nunitosansregular"
                  outlined
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6 pa-2>
                <v-select
                  v-model="sub.teacher"
                  dense
                  style="font-family: nunitosansregular"
                  outlined
                  label="Assign Class Teacher"
                  :items="teacher"
                  item-text="user.name"
                  item-value="_id"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md6 pa-2>
                <v-select
                  v-model="sub.subject"
                  dense
                  style="font-family: nunitosansregular"
                  outlined
                  label="Subject"
                  :items="subject"
                  item-text="subjectName"
                  item-value="_id"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md4 pb-8>
                <v-btn
                  @click="validateInput"
                  dark
                  block
                  height="50px"
                  style="font-family: nunitosanssemibold"
                  color="#9B8DFD"
                  >EDIT CLASS</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-layout justify-center wrap pt-10 pb-5 v-if="user && user.class">
          <v-flex xs12>
            <v-card>
              <v-card-text>
                <v-layout justify-center wrap pl-2>
                  <v-flex xs12 v-if="user.class.className">
                    <span style="font-family: nunitosansbold">{{
                      user.class.className
                    }}</span>
                  </v-flex>
                  <v-flex xs12>
                    <span
                      style="
                        font-family: nunitosansregular;
                        color: #9b8dfd;
                        font-size: 12px;
                      "
                      >Class Added Successfully</span>
                  </v-flex>
                  <v-flex xs12 v-if="user.class.className">
                    <span style="font-family: nunitosansbold; font-size: 14px"
                      >Add Subjects & Teachers for
                      {{ user.class.className }}</span
                    >
                  </v-flex>
                </v-layout>
                <v-layout justify-center wrap pt-3>
                  <v-flex xs12 sm6 md5 pa-2>
                    <v-select
                      v-model="sub.subject"
                      dense
                      style="font-family: nunitosanssemibold"
                      outlined
                      label="Subject"
                      :items="subjectArray"
                      item-text="subjectName"
                      item-value="_id"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md5 pa-2>
                    <v-select
                      v-model="sub.teacher"
                      dense
                      style="font-family: nunitosanssemibold"
                      outlined
                      label="Assign Teacher"
                      :items="teacher"
                      item-text="user.name"
                      item-value="_id"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md2 pa-2>
                    <v-btn
                      @click="validate"
                      block
                      style="font-family: nunitosanssemibold"
                      outlined
                      >ADD</v-btn>
                  </v-flex>
                </v-layout>
                <v-layout justify-start wrap>
                  <v-flex xs12>
                    <v-layout justify-start wrap pb-5>
                      <v-flex
                        xs3
                        sm2
                        md1
                        pt-2
                        text-center
                        v-if="user.teacher.user.photo">
                        <v-avatar style="cursor: pointer" size="48">
                          <v-img
                            width="40px"
                            :src="mediaURL + user.teacher.user.photo"
                          ></v-img>
                        </v-avatar>
                      </v-flex>
                      <v-flex xs9 sm10 md10 v-if="user.teacher.user.name">
                        <span
                          style="
                            color: #000000;
                            font-family: nunitosanssemibold;
                            font-size: 18px;
                          "
                          >{{ user.teacher.user.name }}</span
                        ><br />
                        <span
                          style="
                            color: #000000;
                            font-family: nunitosansbold;
                            font-size: 12px;
                          "
                          >Class Teacher</span
                        ><br />
                        <v-flex xs12 pt-1>
                          <v-layout justify-center wrap>
                            <v-flex xs4 sm2 md2 lg1 v-if="user.class.className">
                              <v-btn color="#9B8DFD" small rounded>
                                <span
                                  style="
                                    color: #ffffff;
                                    font-family: nunitosansbold;
                                  ">
                                  {{ user.class.className }}</span>
                              </v-btn>
                            </v-flex>
                            <v-flex xs8 sm8 md8 lg9>
                              <v-btn small rounded outlined>
                                <span
                                  style="
                                    color: #000000;
                                    font-family: nunitosansregular;
                                    text-transform: none;
                                  ">
                                  {{ user.subject.subjectName }}</span>
                              </v-btn>
                            </v-flex>
                            <v-layout justify-end wrap>
                              <v-flex xs12 sm2 md2 align-self-end>
                                <v-dialog
                                  v-model="editdialog"
                                  max-width="600px">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon size="20" v-bind="attrs" v-on="on"
                                      >mdi-folder-edit-outline</v-icon>
                                  </template>
                                  <v-card>
                                    <v-card-text>
                                      <v-layout justify-center wrap pt-5>
                                        <v-flex v-if="user.teacher" xs12 sm6 md6 pa-2>
                                          <v-select
                                            v-model="user.teacher._id"
                                            dense
                                            style="font-family: nunitosansregular;"
                                            outlined
                                            label="Assign Class Teacher"
                                            :items="teacher"
                                            item-text="user.name"
                                            item-value="_id"
                                          ></v-select>
                                        </v-flex>
                                        <v-flex v-if="user.subject" xs12 sm6 md6 pa-2>
                                          <v-select
                                            v-model="user.subject._id"
                                            dense
                                            style="font-family: nunitosansregular;"
                                            outlined
                                            label="Subject"
                                            :items="subjectArray"
                                            item-text="subjectName"
                                            item-value="_id"
                                          ></v-select>
                                        </v-flex>
                                      </v-layout>
                                    </v-card-text>
                                    <v-card-actions>
                                      <v-spacer></v-spacer>
                                      <v-layout justify-center wrap>
                                        <v-flex xs6 sm4 px-2>
                                          <v-btn
                                            block
                                            tile
                                            color="#757575"
                                            outlined
                                            :ripple="false"
                                            depressed
                                            @click="editdialog = false"
                                          >
                                            Close
                                          </v-btn>
                                        </v-flex>
                                        <v-flex xs6 sm4 px-2>
                                          <v-btn
                                            tile
                                            block
                                            dark
                                            color="#FF1313"
                                            depressed
                                            class="text-capitalize"
                                            :ripple="false"
                                            @click="edit(user._id)"
                                          >
                                            Save
                                          </v-btn>
                                        </v-flex>
                                      </v-layout>
                                    </v-card-actions>
                                  </v-card>
                                </v-dialog>
                              </v-flex>
                            </v-layout>
                          </v-layout>
                        </v-flex>
                      </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                  </v-flex>
                </v-layout>
                <v-layout justify-center wrap>
                  <v-flex xs12 v-for="(item, i) in data" :key="i">
                    <v-layout
                      justify-center
                      wrap
                      py-5
                      v-if="item._id != user._id && item.teacher">
                      <v-flex
                        xs3
                        sm2
                        md1
                        pt-2
                        v-if="item.teacher.user"
                        text-center>
                        <v-avatar
                          v-if="item.teacher.user"
                          style="cursor: pointer"
                          size="48">
                          <v-img
                            width="40px"
                            :src="mediaURL + item.teacher.user.photo"
                          ></v-img>
                        </v-avatar>
                      </v-flex>
                      <v-flex xs9 sm10 md11 v-if="item.teacher.user">
                        <span
                          style="
                            color: #000000;
                            font-family: nunitosanssemibold;
                            font-size: 18px;
                          "
                          >{{ item.teacher.user.name }}</span
                        ><br />
                        <span
                          style="
                            color: #000000;
                            font-family: nunitosansbold;
                            font-size: 12px;
                          "
                          >Teacher</span
                        ><br />
                        <v-layout justify-start wrap>
                          <v-flex xs10 pt-1 v-if="item.teacher">
                            <v-btn small outlined rounded>
                              <span
                                style="
                                  color: #000000;
                                  font-family: nunitosansregular;
                                  text-transform: none;
                                ">
                                {{ item.subject.subjectName }}</span
                              >
                            </v-btn>
                          </v-flex>
                          <v-layout justify-start wrap pl-3>
                            <v-flex xs3 sm4 md3 align-self-end text-right>
                              <v-dialog v-model="item.delete" max-width="600px">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-img
                                    v-on="on"
                                    v-bind="attrs"
                                    width="20"
                                    style="cursor:pointer"
                                    src="../../assets/images/delete.svg">
                                  </v-img>
                                </template>
                                <v-card>
                                  <v-card-title
                                    style="font-family: nunitosansregular">
                                    Are you sure you want to delete this
                                    Teacher?
                                  </v-card-title>
                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      color="blue darken-1"
                                      text
                                      @click="item.delete = false"
                                      >Cancel</v-btn>
                                    <v-btn
                                      color="blue darken-1"
                                      text
                                      @click="deleteItem(item)"
                                      >OK</v-btn>
                                    <v-spacer></v-spacer>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
                            </v-flex>
                            <v-flex xs2 sm4 md2 align-self-end>
                              <v-icon size="20" @click="editingItem=item,editdialog1=true"
                                >mdi-folder-edit-outline</v-icon>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-divider v-if="item._id!=user._id && item.teacher"></v-divider>
                  </v-flex>
                </v-layout>
                <v-layout justify-center wrap pb-10>
                  <v-flex xs12 text-center py-3>
                    <span style="color: #9b8dfd; font-family: nunitosansregular"
                      >Class teacher & {{count.teacherCount-1}} teacher added</span>
                  </v-flex>
                  <!-- <v-flex xs6>
                    <v-btn block dark color="#9B8DFD">SUBMIT</v-btn>
                  </v-flex> -->
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-dialog v-model="editdialog1" max-width="600px">
          <v-card>
            <v-card-text>
              <v-layout justify-center wrap pt-5>
                <v-flex v-if="editingItem.teacher" xs12 sm6 md6 pa-2>
                  <v-select
                    v-model="editingItem.teacher._id"
                    dense
                    style="font-family: nunitosansregular"
                    outlined
                    label="Assign Teacher"
                    :items="teacher"
                    item-text="user.name"
                    item-value="_id"
                  ></v-select>
                </v-flex>
                <v-flex v-if="editingItem.subject"  xs12 sm6 md6 pa-2>
                  <v-select
                    v-model="editingItem.subject._id"
                    dense
                    style="font-family: nunitosansregular"
                    outlined
                    label="Subject"
                    :items="subjectArray"
                    item-text="subjectName"
                    item-value="_id"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-layout justify-center wrap>
                <v-flex xs6 sm4 px-2>
                  <v-btn
                    block
                    tile
                    color="#757575"
                    outlined
                    :ripple="false"
                    depressed
                    @click="editdialog1 = false">
                    Close
                  </v-btn>
                </v-flex>
                <v-flex xs6 sm4 px-2>
                  <v-btn
                    tile
                    block
                    dark
                    color="#FF1313"
                    depressed
                    class="text-capitalize"
                    :ripple="false"
                    @click="editSubjectTeacher(editingItem._id)">
                    Save
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["id"],
  data() {
    return {
      hover: false,
      appLoading: false,
      showsnackbar: false,
      ServerError: false,
      msg: "",
      timeout: 5000,
      editingItem: {},
      editdialog: false,
      editdialog1: false,
      sub: {
        subject: "",
        teacher: "",
      },
      classAdd: {
        standard: "",
        division: "",
        classTeacher: "",
        classTeacherSubject: "",
      },
      studentList: [],
      page: 1,
      classArray: [],
      classid: "",
      standardArray: [],
      section: [],
      teacher: [],
      subject: [],
      subjectArray: [],
      user: [],
      data: [],
      count:[],
    };
  },
  mounted() {
    this.getStandard();
    this.getTeacher();
    this.getSubject();
    this.getData();
  },
  methods: {
    uppercase() {
      this.classAdd.division = this.classAdd.division.toUpperCase();
    },
    validateInput() {
      if (!this.sub.teacher) {
        this.msg = "Please Provide Teacher";
        this.showsnackbarr = true;
        return;
      } else if (!this.sub.subject) {
        this.msg = "Please Provide Subject";
        this.showsnackbar = true;
        return;
      } else {
        this.addClass();
      }
    },
    validate() {
      if (!this.sub.subject) {
        this.msg = "Please Provide Subject";
        this.showsnackbar = true;
        return;
      } else if (!this.sub.teacher) {
        this.msg = "Please Provide Teacher";
        this.showsnackbar = true;
        return;
      } else {
        this.addSubject(this.id);
      }
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/class/subject/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          classid: this.id,
        },
      })
        .then((response) => {
          this.user = response.data.classTeacher;
          this.data = response.data.data;
          this.subjectArray=response.data.subjects
          this.count=response.data
          this.appLoading = false;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getSubject() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/subject/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.subject = response.data.data;
          this.appLoading = false;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getStandard() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/standard/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.standardArray = response.data.data;
          this.appLoading = false;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getTeacher() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/teacher/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.teacher = response.data.data;
          this.appLoading = false;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    addClass() {
      this.appLoading = true;
      var usercls = {};
      usercls["subject"] = this.sub.subject;
      usercls["teacher"] = this.sub.teacher;
      usercls["classid"] = this.id;
      usercls["isClassTeacher"] = true;
      axios({
        method: "POST",
        url: "/class/subject/teacher/update",
        data: usercls,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Class Added Successully";
            this.showsnackbar = true;
            // this.$router.push({ path: "/addClass" });
            // this.classid = response.data.data.class._id;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    addSubject(cid) {
      this.appLoading = true;
      this.sub.classid = cid;
      axios({
        method: "POST",
        url: "/class/subject/teacher/update",
        data: this.sub,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Teacher Added Successully";
            Object.keys(this.sub).forEach((key) => (this.sub[key] = null));
            this.showsnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    edit(id) {
      this.appLoading = true;
      var user = {};
      user["subject"] = this.user.subject._id;
      user["teacher"] = this.user.teacher._id;
      user["classid"] = this.id;
      user["id"]=id;
      user["isClassTeacher"] = true;
      axios({
        method: "POST",
        url: "/class/subject/teacher/update",
        data: user,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.editdialog = false;
            this.msg = "Teacher Update Successully";
            this.showsnackbar = true;
            this.getData();
          } else {
            this.editdialog = false;
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    editSubjectTeacher() {
      this.appLoading = true;
      var user = {};
      user["subject"] = this.editingItem.subject._id;
      user["teacher"] = this.editingItem.teacher._id
      user["classid"] = this.id;
      user["id"] = this.editingItem._id;
      axios({
        method: "POST",
        url: "/class/subject/teacher/update",
        data: user,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.editdialog1 = false;
            this.msg = "Teacher Update Successully";
            this.showsnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    deleteItem(r) {
      var data = {};
      data["id"] = r._id;
      axios({
        url: "/class/subject/teacher/remove",
        method: "POST",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.delete = false;
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Delete Sucessfully";
            this.showsnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>